/**
 * Product API service
 * @module features/products/productService
 */

import api from '../../app/axios';

const getProducts = async (params) => {
  const response = await api.get('/packages', { params });
  return response.data;
};

const MAX_PAGE_SIZE = 50;

const getAllProducts = async (params = {}) => {
  const baseParams = { ...params, page: 1, limit: MAX_PAGE_SIZE };
  const first = await getProducts(baseParams);

  const allProducts = Array.isArray(first.products) ? [...first.products] : [];
  const totalPages = Math.max(1, Number(first?.pagination?.totalPages) || 1);

  if (totalPages > 1) {
    const pageRequests = [];
    for (let page = 2; page <= totalPages; page += 1) {
      pageRequests.push(getProducts({ ...baseParams, page }));
    }

    const pageResults = await Promise.all(pageRequests);
    pageResults.forEach((result) => {
      if (Array.isArray(result?.products)) {
        allProducts.push(...result.products);
      }
    });
  }

  return {
    ...first,
    products: allProducts,
    pagination: {
      ...(first?.pagination || {}),
      page: 1,
      limit: allProducts.length || MAX_PAGE_SIZE,
      total: allProducts.length,
      totalPages: 1,
    },
  };
};

const getProductBySlug = async (slug) => {
  const response = await api.get(`/packages/slug/${slug}`);
  return response.data;
};

const getFilterOptions = async () => {
  const response = await api.get('/packages/filters');
  return response.data;
};

const getCategories = async () => {
  const response = await api.get('/categories');
  return response.data;
};

const getCategoryBySlug = async (slug) => {
  const response = await api.get(`/categories/${slug}`);
  return response.data;
};

const productService = {
  getProducts,
  getAllProducts,
  getProductBySlug,
  getFilterOptions,
  getCategories,
  getCategoryBySlug,
};
export default productService;

// Developed and Designed by Trophy Developers
